export default "https://assets.egbcdn.net/assets/packs/_/images/beer/therese_von_bayern/beer-liquid-88875698dcee40fafef341acf2e1b8f0.png";